<template>
    <div class="ns-today-time-sheet">
        <div class="float-right my-3 flex items-center">
            <el-input v-model="search_emp_by_id_name" class="float-right my-3 mx-5" placeholder="Search by employee name and id"
            style="width: 350px"></el-input>
            <el-button size="medium" icon="el-icon-download" class="action-btn mx-5" @click="exportCSV()">Export CSV</el-button>
        </div>
        <div class="ns-table-section">
            <table v-loading="is_time_sheet_loading" class="ns-table">
                <thead class="ns-sticky-header">
                    <tr>
                        <th>Employee Id</th>
                        <th style="width: 250px;">Employee</th>
                        <th>Location</th> 
                        <th>TIME IN-TIME OUT</th>
                        <th>BREAK <span style="font-size: 0.6rem;">(HH:mm)</span></th>
                        <th>DURATION <span style="font-size: 0.6rem;">(HH:mm)</span></th>
                        <th>COST <span style="font-size: 0.6rem;">(INR)</span></th>
                        <th>STATUS</th>
                    </tr>
                </thead>
                <tbody v-if="computedTimeSheetData">
                    <tr v-for="(time_sheet, time_index) in computedTimeSheetData" :key="time_index" class=" ns-time-sheet-tr">
                        <td> {{ time_sheet.employee_id }} </td>
                        <td> 
                            <div class="title ellipsis">
                                {{ time_sheet.employee_full_name }}
                            </div>
                            <p class="ns-sub-title ns-gray mt-1">{{ time_sheet.employee_department }}</p>
                        </td>
                        <td> {{ getStoreName(time_sheet.store) }} </td>
                        <td> 
                            <div class="mb-2">
                                <span style="margin-right: 33px;" class="font-semibold">Actual:</span>
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.actual_in ? formatTime(time_sheet.actual_in) : '00:00' }}
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.actual_out ? formatTime(time_sheet.actual_out) : '00:00' }}
                            </div>
                            <div class="">
                                <span style="margin-right: 6.6px;">Scheduled: </span>
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.scheduled_start_time ? formatTime(time_sheet.scheduled_start_time) : '00:00' }} 
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.scheduled_end_time ? formatTime(time_sheet.scheduled_end_time) : '00:00' }}
                            </div>
                        </td>
                        <td>
                            <div class="mb-2">
                                <span style="margin-right: 33px;" class="font-semibold">Actual:</span>
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.breaklast_start_datetime ?
                                    formatTime(time_sheet.breaklast_start_datetime) : '00:00' }}
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.breaklast_end_datetime ?
                                    formatTime(time_sheet.breaklast_end_datetime) : '00:00' }}
                            </div>
                            <div class="">
                                <span style="margin-right: 6.6px;">Scheduled: </span>
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.scheduled_break_start_time ?
                                    formatTime(time_sheet.scheduled_break_start_time) : '00:00' }}
                                <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.scheduled_break_end_time ?
                                    formatTime(time_sheet.scheduled_break_end_time) : '00:00' }}
                            </div>
                            <!-- <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.breaklast_start_datetime ? time_sheet.breaklast_start_datetime : '00:00' }}
                            <i class="el-icon-time text-amplitude text-sm ml-2"></i> {{ time_sheet.breaklast_end_datetime ? time_sheet.breaklast_end_datetime : '00:00' }} -->
                        </td>
                        <td> <i class="el-icon-time text-amplitude text-sm"></i> {{ time_sheet.total_duration }} </td>
                        <td>
                            <div class="mb-2">
                                <span style="margin-right: 33px;" class="font-semibold">Actual:</span>
                                <i class="el-icon-wallet text-amplitude text-sm mr-1"></i> <strong>{{ time_sheet.actual_total_cost ? time_sheet.actual_total_cost : '0' }}</strong>
                            </div>
                            <div class="">
                                 <span style="margin-right: 6.6px;">Scheduled: </span>
                                <i class="el-icon-wallet text-amplitude text-sm mr-1"></i> <strong>{{ time_sheet.scheduled_total_cost ? time_sheet.scheduled_total_cost : '0' }}</strong>
                            </div>
                        </td>
                        <td>
                            <el-tag v-if="time_sheet.actual_in && time_sheet.actual_out" type="success" size="mini" effect="plain">Completed</el-tag>
                            <el-tag v-else-if="time_sheet.actual_in && !time_sheet.actual_out" type="warning" size="mini" effect="plain">In Progress</el-tag>
                            <el-tag v-else-if="time_sheet.no_shift" type="info" size="mini" effect="plain">No Shift</el-tag>
                            <el-tag v-else-if="time_sheet.weekoff" type="warning" size="mini" effect="plain">Weekly Off</el-tag>
                            <el-tag v-else-if="time_sheet.leave" type="danger" size="mini" effect="plain">Leave</el-tag>
                            <span v-else> - </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!computedTimeSheetData.length" class="w-full">
                <el-empty description="Data not found !"></el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../../services/labourPalnningService";
import axios from "axios";
import moment from 'moment';
import exportFromJSON from 'export-from-json';
import { mapActions } from "vuex";
export default {
    name: "TodayTimeSheetV2",
    props: {
        selectedStore: {
            type: String,
            default: () => ''
        },
        storeList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            time_sheet_list: [],
            time_sheet_summary: {},
            store_timing: {},
            is_time_sheet_loading: false,
            search_emp_by_id_name: ''
        }
    },
    computed: {
        computedTimeSheetData(){
            let data = [...this.time_sheet_list];
            if(this.search_emp_by_id_name){
                data = data.filter(item =>  
                    item.employee_full_name.toLowerCase().includes(this.search_emp_by_id_name.toLowerCase()) ||
                    item.employee_id.toString().includes(this.search_emp_by_id_name)
                );
            }
            return data;
        }
    },
    watch: {
        selectedStore(newValue, oldValue) {
            if (newValue) {
                this.getTodaysTimeSheetDetails();
            }
        }
    },
    mounted() {
        this.getTodaysTimeSheetDetails();
    },
    methods: {
        ...mapActions("CommonStore",["addDownloadingReportCountAction", "removeDownloadingReportCountAction"]),
        exportCSV(){
            this.addDownloadingReportCountAction();
            let data = this.time_sheet_list.map((el) => ({
				"Employee ID": el.employee_id,
				"Employee Name": el.employee_full_name,
				"Department": el.employee_department,
				"Location ID": el.store_code,
                "Location Name": this.getStoreName(el.store),
				"Schedule Date": moment(el.shift_date).format('YYYY-MM-DD'),
				"Scheduled In Time": el.scheduled_start_time,
				"Scheduled Out Time": el.scheduled_end_time,
				"Actual In Time": el.actual_in,
				"Actual Out Time": el.actual_out,
				"Scheduled Break Start Time": el.scheduled_break_start_time,
				"Scheduled Break End Time": el.scheduled_break_end_time,
				"Actual Break Start Time": el.breaklast_start_datetime,
				"Actual Break End Time": el.breaklast_end_datetime,
				"Actual Cost": el.actual_total_cost,
				"Duration": el.total_duration,
				"Status": el.completion_rate
			}));
			const fileName =
				"TimeSheet_" + this.startDate + "_to_" + this.endDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
            this.removeDownloadingReportCountAction();
        },
        getTodaysTimeSheetDetails() {
            if (this.selectedStore) {
                this.is_time_sheet_loading = true;
                let timesheet_params = {
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                    filters: {
                        outlets: [this.selectedStore],
                        regions: [],
                        subregions: [],
                        countries: []
                    }
                };

                let store_time_params = {
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                    outlet: this.selectedStore
                };
                axios.all([this.completeTimeSheetDetails(timesheet_params), this.getStoreTime(store_time_params)])
                    .then(axios.spread((timesheetRes, storeTimeRes) => {
                        if (timesheetRes.status == 200 && storeTimeRes.status == 200) {
                            this.time_sheet_list = JSON.parse(timesheetRes.data).timesheets;
                            this.time_sheet_summary = JSON.parse(timesheetRes.data).summary;
                            this.$store.commit('commitTimesheetSummary', this.time_sheet_summary);
                            this.store_timing = JSON.parse(storeTimeRes.data);
                        }
                    }))
                    .catch(err => {
                        console.log(err);
                        this.is_time_sheet_loading = false;
                    })
                    .finally(() => {
                        this.is_time_sheet_loading = false;
                    });
            }
        },
        async completeTimeSheetDetails(params) {
            try {
            const response=await api.completeTimesheetDetailskNetworkCallBack(params);
            return response;
          } catch(e) {
            console.log('error', e);
          }
        },

        async getStoreTime(params) {
            try {
            const response=await api.storeOpenCloseTime(params);
            return response;
          } catch(e) {
            console.log('error', e);
          }
        },

        getStoreName(id){
            let store = {name: '-'};
            if(this.storeList.length){
                store = this.storeList.find((e)=> e.id === id);
            }
            return store.name;
        },
        formatTime(time){
            if (!time) {
                return '-';
            }
            return moment(time).format('hh:mm A')
        },
    },
}
</script>

<style lang="scss" scoped>
.ns-table-section {
    width: 100%;
    margin-top: 15px;
    height: 57vh;
    overflow-y: scroll;
}
.ns-sticky-header{
    position: sticky;
    top: 0;
    color: #707070;
    background-color: #f2f2f2!important;
    tr th {
        text-transform: uppercase !important;
        // text-align: center;
    }
}
.ns-time-sheet-tr{
    td{
        font-size: 13px !important;
    }
}
.title{
            font-weight: bold;
            font-size: 0.7rem;
        }
.ellipsis{
    white-space: nowrap;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.ns-sub-title{
    font-size: 10px;
    font-weight: 600;
} 
.ns-gray{
    color: #707070;
}
.action-btn {
    background-color: #e29d5a;
    border-color: #e29d5a;
    color: #fff;
}
</style>